import React, {PureComponent} from 'react'
import Icon from '../Icon'
import Button from '../Button'
import ButtonGroup from '../ButtonGroup'
import "./ImageComentator.sass"

{/* eslint-disable */}
export default class ImageComentator extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      layers: this.props.layers || [],
      show: false,
      value: '',
      x: '',
      y: ''
    }
  }

  handleClose = () => {
    this.setState({ show: false })
  }

  handleShow = () => {
    this.setState({ show: true })
  }

  onMouseDown = (e) => {
    const obj = document.getElementById('preview').getBoundingClientRect()
    const objX = obj.x
    const objY = obj.y
    const shiftX = e.pageX - objX
    const shiftY = e.pageY - objY
    this.setState({x: shiftX, y: shiftY})
  }

  onTextAdd = (newText) => {
    const newLayer = this.state.layers.slice()
    newLayer.unshift(newText)
    this.setState({layers: newLayer})
  }

  handleTextAdd = () => {
    const newText = {
      text: this.state.value,
      id: Date.now(),
      x: this.state.x,
      y: this.state.y
    }
    if (newText.text.length > 0) {
      this.onTextAdd(newText)
      this.setState({value: '', show: false})
    }
  }

  handleChange = (e) => {
    this.setState({value: e.target.value})
  }

  handleLayerDelete = (layer, e) => {
    const layerId = layer.id
    const newLayers = this.state.layers.filter(layer => layer.id !== layerId)
    this.setState({ layers: newLayers })
    e.preventDefault()
    e.stopPropagation()
  }

  render() {
    const {widthHolst, heightHolst, children} = this.props
    const {value, layers, show} = this.state
    return (
      <div className="image-editor-wrapper">
        <div className="image-editor">
          <div className="image-sidebar">
            <h3>кликнете на изображение чтобы добавить коментарий</h3>
          </div>
          <div className="image-preview" style={{width: widthHolst, height: heightHolst}}>
            {show ?
              <div
                className="image-preview__message"
                style={{
                  left: this.state.x - 128,
                  top: this.state.y + 8
                }}
              >
                <div className="add-layer input-wrapper">
                  <input id="textMessage" className={value && 'label-min'} type="text" onChange={this.handleChange} value={value} autoFocus  />
                  <label htmlFor="textMessage">Введить сообщение</label>
                </div>
                <ButtonGroup justified>
                  <Button bsStyle='primary' onClick={this.handleTextAdd}>Сохранить</Button>
                  <Button onClick={this.handleClose}>Отмена</Button>
                </ButtonGroup>
              </div>:''
            }
            <svg
              id="preview"
              className='dragging'
              height='100%'
              width='100%'
              onClick={this.handleShow}
              onMouseDown={this.onMouseDown}
            >
              {layers.map((layer) =>{
                return  (
                  <g key={layer.id} transform={`translate(${layer.x - 127}, ${layer.y })`}>
                    <foreignObject width="250" height="50" >
                      <div className="svg-flex">
                        <span className="arrow-bottom-svg" />
                        <p
                          onClick={ event => {
                            event.preventDefault()
                            event.stopPropagation()
                          }}
                          className="svg-text-comment"
                        >
                          {layer.text}
                          <Icon onClick={this.handleLayerDelete.bind(null, layer)} className="svg-text-delete" type="trash"/>
                        </p>
                      </div>
                    </foreignObject>
                  </g>
                )
              })}
            </svg>
            {children}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./components/ImageComentator/index.jsx